export default "__VITE_ASSET__JsQ5zFB8__"